import React from "react";
import PropTypes from "prop-types";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// TODO Change name in 
const VaporVerticalLine = props => {
  const { children } = props;
  return (
    <div className={`vapor-timeline ${children?.length > 1 ? "enable-line" : ""}`}>
      {
        children?.map((child, idx) => {
          return (
            <div key={`Vapor_timeline_${idx}`} className='vapor-timeline-row'>
              <FontAwesomeIcon
                icon={["far", "check-circle"]}
                style={{
                  color: "rgb(0, 80, 117)", background: "white",
                  zIndex: 1
                }}
              />
              {child}
            </div>);
        })
      }
    </div>
  );
};

VaporVerticalLine.propTypes = {
  children: PropTypes.object
};

VaporVerticalLine.defaultProps = {
  children: undefined
};

export default VaporVerticalLine;
